import {useEffect} from 'react';
import {useOktaAuth} from '@okta/okta-react';
import {Navigate} from 'react-router-dom';

export function SessionReset() {
    const {oktaAuth} = useOktaAuth();

    useEffect(() => {
        oktaAuth.closeSession();
    });

    return <Navigate to='/'/>;
}
